import { render, staticRenderFns } from "./model3.vue?vue&type=template&id=0189cab2&scoped=true"
import script from "./model3.vue?vue&type=script&lang=js"
export * from "./model3.vue?vue&type=script&lang=js"
import style0 from "./model3.vue?vue&type=style&index=0&id=0189cab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0189cab2",
  null
  
)

export default component.exports